// import "./AppSwiper.css";

// import { Swiper } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// export default function AppSwiper({
//   children,
//  className = "",
//   slidesPerView = 6,

//   spaceBetween = 20,

//   autoplay = false,

//   navigation = true,

//   pagination = false,

//   loop = false,

//   centeredSlides = false,

//   breakpoints,
// }) {
//   return (
//     <div className={`app-swiper ${className}`}>
//     <Swiper
//       modules={[Navigation, Pagination, Autoplay]}
//       navigation={navigation}
//       pagination={pagination ? { clickable: true } : false}
//       autoplay={
//         autoplay
//           ? {
//               delay: 3500,
//               disableOnInteraction: false,
//             }
//           : false
//       }
//       centeredSlides={centeredSlides}
//       loop={loop}
//       spaceBetween={spaceBetween}
//       slidesPerView={slidesPerView}
//       breakpoints={
//         breakpoints || {
//           0: {
//             slidesPerView: 2.2,
//           },

//           576: {
//             slidesPerView: 3.2,
//           },

//           768: {
//             slidesPerView: 4.2,
//           },

//           992: {
//             slidesPerView: 5.2,
//           },

//           1200: {
//             slidesPerView: 6,
//           },
//         }
//       }
//     >
//       {children}
//     </Swiper>
//     </div>
//   );
// }



// import "./AppSwiper.css";

// import { Swiper, SwiperSlide } from "swiper/react";

// import {
//   Navigation,
//   Pagination,
//   Autoplay,
// } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// export default function AppSwiper({
//   children,
//   className = "",
//   slidesPerView = 6,
//   spaceBetween = 20,
//   autoplay = false,
//   navigation = true,
//   pagination = false,
//   loop = false,
// }) {

//   const slides = Array.isArray(children)
//     ? children
//     : [children];

//   return (
//     <div
//       className={`app-swiper ${className}`}
//     >

//       <Swiper
//         modules={[
//           Navigation,
//           Pagination,
//           Autoplay,
//         ]}

//         slidesPerView={slidesPerView}

//         spaceBetween={spaceBetween}

//         navigation={navigation}

//         pagination={
//           pagination
//             ? {
//               clickable: true,
//               dynamicBullets: true,
//             }
//             : false
//         }

//         loop={loop}

//         autoplay={
//           autoplay
//             ? {
//               delay: 4000,
//               disableOnInteraction: false,
//             }
//             : false
//         }

//         breakpoints={{
//           0: {
//             slidesPerView: 1.2,
//             spaceBetween: 10,
//           },

//           480: {
//             slidesPerView: 2,
//             spaceBetween: 12,
//           },

//           768: {
//             slidesPerView: 3,
//             spaceBetween: 14,
//           },

//           992: {
//             slidesPerView: 4,
//             spaceBetween: 16,
//           },

//           1200: {
//             slidesPerView: slidesPerView,
//             spaceBetween: spaceBetween,
//           },
//         }}

//         className="app-swiper__instance"
//       >

//         {slides.map((child, index) => (
//           <SwiperSlide
//             key={
//               child?.key ??
//               `slide-${index}`
//             }
//           >
//             {child}
//           </SwiperSlide>
//         ))}

//       </Swiper>

//     </div>
//   );
// }


// import { Swiper, SwiperSlide } from "swiper/react";
// import {
//     Navigation,
//     Pagination,
//     Autoplay,
// } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";

// import "./AppSwiper.css";

// export default function AppSwiper({
//     children,
//     className = "",
//     slidesPerView = 1,
//     spaceBetween = 10,
//     navigation = false,
//     pagination = false,
//     autoplay = false,
//     loop = false,
//     breakpoints = undefined,
// }) {
//     return (
//         <div className={`app-swiper ${className}`}>

//             <Swiper
//                 modules={[
//                     Navigation,
//                     Pagination,
//                     Autoplay,
//                 ]}
//                 slidesPerView={slidesPerView}
//                 spaceBetween={spaceBetween}
//                 navigation={navigation}
//                 pagination={pagination}
//                 autoplay={autoplay}
//                 loop={loop}
//                 breakpoints={breakpoints}
//                 dir="rtl"
//             >
//                 {children.map((child, index) => (
//                     <SwiperSlide key={index}>
//                         {child}
//                     </SwiperSlide>
//                 ))}
//             </Swiper>

//         </div>
//     );
// }

import { Children } from "react";

import {
    Swiper,
    SwiperSlide,
} from "swiper/react";

import {
    Navigation,
    Pagination,
    Autoplay,
} from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./AppSwiper.css";

export default function AppSwiper({
    children,
    className = "",

    slidesPerView = 1,
    spaceBetween = 20,

    navigation = false,
    pagination = false,

    autoplay = false,
    loop = false,

    breakpoints = undefined,

    allowTouchMove = true,
    simulateTouch = true,

    direction = "rtl",
}) {
    const slides = Children.toArray(children);

    return (
        <div
            className={`app-swiper ${className}`}
            dir={direction}
        >

            <Swiper
                modules={[
                    Navigation,
                    Pagination,
                    Autoplay,
                ]}

                direction="horizontal"

                slidesPerView={slidesPerView}

                spaceBetween={spaceBetween}

                navigation={navigation}

                pagination={
                    pagination
                        ? {
                              clickable: true,
                              dynamicBullets: true,
                          }
                        : false
                }

                autoplay={
                    autoplay
                        ? {
                              delay: 4000,
                              disableOnInteraction: false,
                          }
                        : false
                }

                loop={loop}

                breakpoints={breakpoints}

                allowTouchMove={allowTouchMove}

                simulateTouch={simulateTouch}

                observer={true}

                observeParents={true}

                resizeObserver={true}

                watchOverflow={true}
            >

                {slides.map((child, index) => (
                    <SwiperSlide
                        key={child.key ?? `slide-${index}`}
                    >
                        {child}
                    </SwiperSlide>
                ))}

            </Swiper>

        </div>
    );
}